var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPols(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.617 3c2.71 0 4.955.894 6.72 2.681C29.108 7.471 30 9.733 30 12.48c0 2.745-.89 5.007-2.653 6.796-1.766 1.788-4.01 2.681-6.72 2.681h-5.083v7.27H9.498v-3.977a6.022 6.022 0 0 0 4.182-5.737 6.02 6.02 0 0 0-4.182-5.738V3h11.12zm-.936 14.02c1.23 0 2.229-.429 3.01-1.278.783-.847 1.182-1.933 1.173-3.255 0-1.323-.39-2.408-1.172-3.256-.79-.848-1.79-1.277-3.009-1.277h-4.145v9.068h4.146zm-9.2 5.64a4.39 4.39 0 0 1-3.1 1.291v-.002A4.386 4.386 0 0 1 3 19.554a4.387 4.387 0 0 1 4.38-4.392c2.42 0 4.38 1.966 4.38 4.394a4.387 4.387 0 0 1-1.28 3.104z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPols);
export default __webpack_public_path__ + "static/media/POLS.9bfd67b56719e4fe1034128ed61e9552.svg";
export { ForwardRef as ReactComponent };